import {Injectable} from '@angular/core';
import * as Keycloak from "keycloak-js";
import {IKeyCloakConfig, KeyCloakConfig} from "./keycloak-config";

@Injectable()
export class KeycloakService {
  static auth: any = {};
  static username;

  constructor() {}
  static init(): Promise<void> {

    const keycloakConfig: IKeyCloakConfig = KeyCloakConfig.getConfig();

    var keycloakAuth = Keycloak({
      "realm": keycloakConfig.realm,
      "url": keycloakConfig.url,
      "clientId": keycloakConfig.frontendClient
    });

    KeycloakService.auth.loggedIn = false;

    return new Promise<void>((resolve, reject) => {
      keycloakAuth
        .init({ onLoad: 'login-required', checkLoginIframe: false })
        .then((authenticated: boolean) => {
          KeycloakService.auth.authz = keycloakAuth;
          KeycloakService.auth.logoutUrl =
            keycloakAuth.authServerUrl +
            "/realms/" +
            keycloakAuth.realm +
            "/protocol/openid-connect/logout?" +
            "id_token_hint=" +
            keycloakAuth.idToken +
            "&post_logout_redirect_uri=" +
            document.baseURI;
          KeycloakService.username = KeycloakService.auth.authz.idTokenParsed.preferred_username;
          // If the user is hidden (i.e. system user) force the user to logout.
          if (KeycloakService.auth.authz.idTokenParsed.isHidden === 'true') {
            KeycloakService.auth.loggedIn = false;
            KeycloakService.auth.authz = null;
            window.location.href = KeycloakService.auth.logoutUrl;
          } else {
            KeycloakService.auth.loggedIn = true;
            resolve();
          }
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  }

  logout() {
    KeycloakService.auth.loggedIn = false;
    KeycloakService.auth.authz = null;
    window.location.href = KeycloakService.auth.logoutUrl;
  }

  getToken(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (KeycloakService.auth.authz.token) {
        KeycloakService.auth.authz
          .updateToken(90)
          .then(() => {
            resolve(String(KeycloakService.auth.authz.token));
          })
          .catch(() => {
            reject('Failed to refresh token');
          });
      } else {
        reject('Not logged in');
      }
    });
  }

}
